import { transition, trigger, useAnimation } from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { fadeIn } from 'ng-animate';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { UnpStatus } from '$shared/components/unp-status/unpStatus';
import { translit } from '$core/helpers/translit';
import { validateUnp } from '$shared/validators/isValidUnp';
import { UnpStatusService } from '$shared/components/unp-status/unp-status.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-unp-status',
  templateUrl: './unp-status.component.html',
  styleUrls: ['./unp-status.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', useAnimation(fadeIn), {
        params: { timing: 0.2 },
      }),
    ]),
  ],
})
export class UnpStatusComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public unp!: string;
  @Output() public isAccessStatus = new EventEmitter<boolean>();
  public showUnpStatus!: boolean;
  public unpStatus: UnpStatus;
  public isLoading = false;

  private _statusTranslit: string;
  public get statusTranslit() {
    return translit(this._statusTranslit.toUpperCase());
  }

  public set statusTranslit(value: string) {
    this._statusTranslit = value;
  }

  constructor(private unpStatusService: UnpStatusService) {}

  public ngOnInit() {}

  public ngOnDestroy(): void {}

  public ngOnChanges(): void {
    if (this.unp && this.unp.length === 9) {
      if (validateUnp(this.unp)) {
        this.getUnpStatus(this.unp);
      } else {
        this.showUnpStatus = false;
      }
    } else {
      this.showUnpStatus = false;
    }
  }

  private getUnpStatus(unp: string) {
    this.isLoading = true;
    this.unpStatusService
      .getStatus(unp)
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (res) => {
          this.unpStatus = res;
          this.statusTranslit = res.status;
          this.showUnpStatus = !!res;
          this.isAccessStatus.emit(res.is_access_status);
        },
        () => {
          this.showUnpStatus = false;
        }
      );
  }
}
